import * as Types from '../../../api';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UpdateDomainE164RangesMutationVariables = Types.Exact<{
  id: Types.Scalars['Int']['input'];
  ranges: Array<Types.E164Range>;
}>;


export type UpdateDomainE164RangesMutation = { __typename?: 'Mutation', updateDomainE164Ranges: { __typename?: 'MutationResult', errors?: Array<{ __typename?: 'Error', context?: string | null, location: Array<string>, type: string }> | null } };


export const UpdateDomainE164RangesDocument = gql`
    mutation updateDomainE164Ranges($id: Int!, $ranges: [E164Range!]!) {
  updateDomainE164Ranges(id: $id, ranges: $ranges) {
    errors {
      context
      location
      type
    }
  }
}
    `;
export type UpdateDomainE164RangesMutationFn = Apollo.MutationFunction<UpdateDomainE164RangesMutation, UpdateDomainE164RangesMutationVariables>;

/**
 * __useUpdateDomainE164RangesMutation__
 *
 * To run a mutation, you first call `useUpdateDomainE164RangesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDomainE164RangesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDomainE164RangesMutation, { data, loading, error }] = useUpdateDomainE164RangesMutation({
 *   variables: {
 *      id: // value for 'id'
 *      ranges: // value for 'ranges'
 *   },
 * });
 */
export function useUpdateDomainE164RangesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDomainE164RangesMutation, UpdateDomainE164RangesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDomainE164RangesMutation, UpdateDomainE164RangesMutationVariables>(UpdateDomainE164RangesDocument, options);
      }
export type UpdateDomainE164RangesMutationHookResult = ReturnType<typeof useUpdateDomainE164RangesMutation>;
export type UpdateDomainE164RangesMutationResult = Apollo.MutationResult<UpdateDomainE164RangesMutation>;
export type UpdateDomainE164RangesMutationOptions = Apollo.BaseMutationOptions<UpdateDomainE164RangesMutation, UpdateDomainE164RangesMutationVariables>;